export const changeToMap = (arr, key) => arr.reduce(
  (obj, item) => Object.assign(obj, { [item[`${key}`]]: item }), {});

// Function to filter by array of values
export const filterByArray = (array, key, values) => {
  return array.filter(item => !values.includes(item[key]));
};